const pj = {
  C001Areas: 'PJ/Catalogos/GetAreas',
  C002Materias: 'PJ/Catalogos/GetMaterias',
  C004TipoDocumento: 'PJ/Catalogos/GetTiposDeDocumentos',
  C005PuestosJuridicos: 'PJ/Catalogos/GetPuestosJuridicos',
  C006PuestosAdministrativos: 'PJ/Catalogos/GetPuestosAdministrativos',
  C008Delitos: 'PJ/Catalogos/GetDelitos',
  C009PartidosJudiciales: 'PJ/Catalogos/GetPartidosJudiciales',
  C010Municipios: 'PJ/Catalogos/GetMunicipios',
  C011EntidadesFederativas: 'PJ/Catalogos/GetEntidadesFederativas',
  C012TiposSexo: 'PJ/Catalogos/GetTiposSexos',
  C020Salas: 'PJ/Catalogos/GetSalas',
  C024TipoAudiencia: 'PJ/Catalogos/GetTiposAudiencias',
  C027TiposTitulo: 'PJ/Catalogos/GetTiposTitulos',
  C029TipoPersonalidad: 'PJ/Catalogos/GetTiposPersonalidades',
  C031Sistemas: 'PJ/Catalogos/GetSistemas',
  C034TiposEvidencia: 'PJ/Catalogos/GetTiposEvidencias',
  C037Paises: 'PJ/Catalogos/GetPaises',
  C039TiposDepartamentos: 'PJ/Catalogos/GetTiposDepartamentos',
  C038TiposIdentificacion: 'PJ/Catalogos/GetTiposIdentificacion',
  C041TiposEstadosCiviles: 'PJ/Catalogos/GetTiposEstadosCiviles',
  C042Juicios: 'PJ/Catalogos/GetJuicios',
  C042JuiciosTemisCivil: 'PJ/Catalogos/GetJuicios_TemisCivil',
  C044TiposPuestos: 'SIAP/Catalogos/GetTiposPuestos',
  C045Puestos: 'PJ/Catalogos/GetPuestos',
  C046Tramites: 'PJ/Catalogos/GetTramites',
  C046TramitesTemisCivil: 'PJ/Catalogos/GetTramites_TemisCivil',
  C048TiposFirmaElectronica: 'PJ/Catalogos/GetTiposFirmasElectronicas',
  C051Anexos: 'PJ/Catalogos/GetAnexos',
  C052NivelesPuestos: 'SIAP/Catalogos/GetTiposNivelesPuestos', // mover este al archivo al que corresponde (en SIAP) y no aqui en PJ
  C060TiposCategoriasPuestos: 'PJ/Catalogos/GetTiposCategoriasPuestos',
  C057TipoIconos: 'PJ/Catalogos/GetTiposIconos'
};

export default pj;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/PJ/catalogos/pj.js
// module id = null
// module chunks = 